import { render, staticRenderFns } from "./StreamBarcodeReader.vue?vue&type=template&id=0bf0b890&scoped=true&"
import script from "./StreamBarcodeReader.vue?vue&type=script&lang=js&"
export * from "./StreamBarcodeReader.vue?vue&type=script&lang=js&"
import style0 from "./StreamBarcodeReader.vue?vue&type=style&index=0&id=0bf0b890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf0b890",
  null
  
)

export default component.exports